import { STYLES_NAME as STYLES_NAME_KUBIT } from '@kubit/web-ui-components/constants/stylesName';
export const STYLES_NAME = {
    ...STYLES_NAME_KUBIT,
    HEADER: 'HEADER_STYLES',
    ERROR_TEXT: 'ERROR_TEXT_STYLES',
    SELECTOR_CARD_EXPANDER: 'SELECTOR_CARD_EXPANDER_STYLES',
    SELECTOR_CARD_IMAGE: 'SELECTOR_CARD_IMAGE_STYLES',
    LOADER_CONTAINER: 'LOADER_CONTAINER_STYLES',
    QUICK_BUTTON_CONTAINER: 'QUICK_BUTTON_CONTAINER_STYLES',
    SELECTION_INDICATOR: 'SELECTION_INDICATOR_STYLES',
    INFORMATIVE_CARD: 'INFORMATIVE_CARD_STYLES',
    BADGE_LOGO: 'BADGE_LOGO_STYLES',
    QUICK_BUTTON_COMPLEX: 'QUICK_BUTTON_COMPLEX_STYLES',
    NAVIGATION_CARD_BANK: 'NAVIGATION_CARD_BANK_STYLES',
    NAVIGATION_CARD_CONTAINER: 'NAVIGATION_CARD_CONTAINER_STYLES',
    SELECTOR_CARD_CONTENT: 'SELECTOR_CARD_CONTENT_STYLES',
    SWITCH_CARD: 'SWITCH_CARD_STYLES',
    CHART_LEGEND: 'CHART_LEGEND_STYLES',
    PRODUCT_CARD: 'PRODUCT_CARD_STYLES',
    SELECTOR_ROW_AGENDA: 'SELECTOR_ROW_AGENDA_STYLES',
    AVATAR_PROFILE: 'AVATAR_PROFILE_STYLES',
    NAVIGATION_STATUS_CARD: 'NAVIGATION_STATUS_CARD_STYLES',
    STACKABLE_CARD: 'STACKABLE_CARD_STYLES',
    SUMMARY_CARD: 'SUMMARY_CARD_STYLES',
    DRAGGABLE_ITEM: 'DRAGGABLE_ITEM_STYLES',
    DRAGGABLE_CONTAINER: 'DRAGGABLE_CONTAINER_STYLES',
    NAVBAR: 'NAVBAR_STYLES',
    PROGRESS_BAR_COMPLEX: 'PROGRESS_BAR_COMPLEX_STYLES',
    INPUT_ACTION: 'INPUT_ACTION_STYLES',
    INPUT_CURRENCY_LARGE: 'INPUT_CURRENCY_LARGE_STYLES',
    INPUT_QUANTITY: 'INPUT_QUANTITY_STYLES',
    INPUT_RELATED: 'INPUT_RELATED_STYLES',
    SEGMENTED_CONTROL: 'SEGMENTED_CONTROL_STYLES',
    CLOSE_BUTTON: 'CLOSE_BUTTON_STYLES',
    MODAL_CONTAINER: 'MODAL_CONTAINER_STYLES',
    ACCORDION_WITH_TOGGLE: 'ACCORDION_WITH_TOGGLE_STYLES',
    RANGE_GROUP: 'RANGE_GROUP',
    INPUT_DATE: 'INPUT_DATE_STYLES',
    INPUT_DATE_V2: 'INPUT_DATE_STYLES_V2',
    INPUT_DATE_INT: 'INPUT_DATE_INT_STYLES',
    CALENDAR: 'CALENDAR_STYLES',
    CHIPS_CONTAINER: 'CHIPS_CONTAINER_STYLES',
    BUBBLE: 'BUBBLE_STYLES',
    PRODUCT_DRAWER: 'PRODUCT_DRAWER_STYLES',
    LOADER_SIZE: 'LOADER_SIZE_STYLES',
    CHECKBOX_CONTAINER: 'CHECKBOX_CONTAINER_STYLES',
    ICON_BUTTON: 'ICON_BUTTON_STYLES',
    CALL_OUT_ALERT: 'CALL_OUT_ALERT_STYLES',
    COMMERCIAL_CARD: 'COMMERCIAL_CARD_STYLES',
    LOAD_MORE_CONTAINER: 'LOAD_MORE_CONTAINER_STYLES',
    INSIGHT: 'INSIGHT_STYLES',
    STEPPER: 'STEPPER_STYLES',
    STACKABLE_ROW: 'STACKABLE_ROW_STYLES',
    PDF_VIEWER: 'PDF_VIEWER_STYLES',
    PILL_PRODUCT: 'PILL_PRODUCT_STYLES',
    SELECTOR_CARD_OPERATIVE: 'SELECTOR_CARD_OPERATIVE_STYLES',
    SELECT: 'SELECT',
    NAVIGATION_ROW_PRODUCT: 'NAVIGATION_ROW_PRODUCT',
    DOC_READER: 'DOC_READER_STYLES',
    FILE_UPLOADER: 'FILE_UPLOADER_STYLES',
    NOTIFICATIONS: 'NOTIFICATIONS_STYLES',
    TAB_FAB: 'TAB_FAB_STYLES',
    FLOATING_BUTTON: 'FLOATING_BUTTON_STYLES',
    BADGE_ICON: 'BADGE_ICON_STYLES',
    CARD_CONTAINER: 'CARD_CONTAINER_STYLES',
    BROWSER_TABS: 'BROWSER_TABS_STYLES',
    RADIO_BUTTON_GROUP_V2: 'RADIO_BUTTON_GROUP_STYLES_V2',
    LAYOUT_CARD: 'LAYOUT_STYLES_CARD',
    SELECTOR_ROW: 'SELECTOR_ROW_STYLES',
    SELECTOR_ROW_V2: 'SELECTOR_ROW_STYLES_V2',
    FEEDBACK_BUTTON: 'FEEDBACK_BUTTON_STYLES',
    CONTEXT_MENU: 'CONTEXT_MENU_STYLES',
    RISK_INDEX: 'RISK_INDEX_STYLES',
    RATING: 'RATING_STYLES',
    ACCORDION_ROW: 'ACCORDION_ROW_STYLES',
    FLOATING_BUTTON_EXTENDED: 'FLOATING_BUTTON_EXTENDED_STYLES',
    INPUT_ERROR_MESSAGE: 'INPUT_ERROR_MESSAGE_STYLES',
    INPUT_HELP_MESSAGE: 'INPUT_HELP_MESSAGE_STYLES',
    EMPTY_STATE: 'EMPTY_STATE_STYLES',
    INPUT_V2: 'INPUT_V2_STYLES',
    INPUT_SEARCH_V2: 'INPUT_SEARCH_V2_STYLES',
    INPUT_DROPDOWN_V2: 'INPUT_DROPDOWN_V2_STYLES',
    AMOUNT_MASK: 'AMOUNT_MASK_STYLES',
    AMOUNT_MASK_V2: 'AMOUNT_MASK_V2_STYLES',
    RISK_LEVEL_BAR: 'RISK_LEVEL_BAR_STYLES',
    BASIC_CARD: 'BASIC_CARD_STYLES',
    ACCORDION_SECTION: 'ACCORDION_SECTION_STYLES',
    RISK_INDEX_CNMV: 'RISK_INDEX_CNMV_STYLES',
    CARD_SELECTOR: 'CARD_SELECTOR_STYLES',
    DROPDOWN_MULTISELECT: 'DROPDOWN_MULTISELECT',
    TEXT_COUNT_V2: 'TEXT_COUNT_V2_STYLES',
    TABS_V2: 'TABS_STYLES_V2',
    DATE_RANGE: 'DATE_RANGE_STYLES',
    ASYNC_IMAGE: 'ASYNC_IMAGE_STYLES',
    FILE_MANAGER: 'FILE_MANAGER_STYLES',
    INPUT_PHONE: 'INPUT_PHONE_STYLES',
    ANIMATION_CARD_ON_OFF: 'ANIMATION_CARD_ON_OFF_STYLES',
    INPUT_CURRENCY_CONVERTER: 'INPUT_CURRENCY_CONVERTER_STYLES',
    SCROLL_CONTROL: 'SCROLL_CONTROL_STYLES',
    ACCORDION_V2: 'ACCORDION_V2_STYLES',
    ACCORDION_V2_PRODUCT: 'ACCORDION_V2_PRODUCT_STYLES',
    PDF_THUMBNAIL: 'PDF_THUMBNAIL_STYLES',
};
//# sourceMappingURL=stylesName.js.map